<template>
  <v-img
    :src="require(`@/assets/images/insurers/${insurer.logo}`)"
    :width="width"
    :height="height"
    class="mx-auto"
    contain
  ></v-img>
</template>

<script>
export default {
  mixins: [],

  components: {},

  props: {
    insurer: Object,
    small: Boolean,
  },

  data() {
    return {};
  },

  methods: {},

  computed: {
    smallSize() {
      return this.small ? 50 : 0;
    },

    width() {
      return (this.insurer.width || 200) - this.smallSize;
    },
    height() {
      return (this.insurer.height || 100) - this.smallSize;
    },
  },
};
</script>
